module.exports = __webpack_public_path__ + "static/img/1.507ebc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/1.png
// module id = J9A9
// module chunks = 0